import { useCallback, useEffect, useRef, useState } from "react"
import { key_local_storage_cart, url_images, urlapi } from "../../lib/backend/data"
import Carrito from "../Header/carrito"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import DireccionUsuario from "../Header/ingresoDireccion"
import { GoGift } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux"
import { Link, Navigate } from "react-router-dom"
import { FaAngleLeft } from "react-icons/fa"
import { refrescarUser } from "../../redux/actions/user"
import DespachoOrden from "../../subComponents/ordenes/despacho"
import { FaCheck, FaTruckFast } from "react-icons/fa6"
import { formatoMoneda, validateEmail } from "../../lib/helpers/helpers"
import Skeleton from "react-loading-skeleton"
import paymentData from "./data"
import { calculateTotalCart } from "../../lib/helpers/main"
import PointerHand from "../../subComponents/animations/pointerHand"
import { Alert, debounce, LinearProgress, Snackbar } from "@mui/material"
import { IoIosRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"
import { MdOutlineDiscount } from "react-icons/md"

const logos = paymentData.logos
const descripciones = paymentData.descripciones

const Checkout = () => {
    const [idPedido, setIdPedido] = useState('')
    const [carrito, setCarrito] = useState(localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart)) : [])
    const [paymentMethod, setPaymentMethod] = useState(false)
    const [shipmentMethod, setShipmentMethod] = useState(false)
    const direcciones = useSelector(state => state.direcciones)
    const [snack, setSnack] = useState({ open: false, message: "", severity: "info" })
    const sitio = useSelector(state => state.sitio)
    const [loadingDiscount, setLoadingDiscount] = useState(false)
    const [loading, setLoading] = useState(false)
    const [discountValid, setDiscountValid] = useState(false)
    const dispatch = useDispatch()
    const [discountCode, setDiscountCode] = useState("")
    const [metodos_pago, setMetodosPago] = useState([])
    const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false)
    const user = useSelector(state => state.user)
    const [key_shipment, setKeyShipment] = useState(1)
    const [userState, setUserState] = useState(user)
    const [inventoryCheck, setInventoryCheck] = useState(null)
    const [inventoryAlert, setInventoryAlert] = useState(null)
    const [checkout, setCheckout] = useState({
        isGift: false,
        giftOptions: {}
    })
    const [loadingTrash, setLoadingTrash] = useState(false)
    const [trashedIds, setTrashedIds] = useState([])
    const lastPaymentTracked = useRef(null)

    const logos = {
        "webpay": `${url_images}/payments_methods/webpay.png`,
        "transbank": `${url_images}/payments_methods/webpay.png`,
        "khipu": `${url_images}/payments_methods/khipu.webp`,
        "fintoc": `${url_images}/payments_methods/fintoc.svg`,
        "mercado-pago": `${url_images}/payments_methods/mercado-pago.png`
    }

    const showSnack = useCallback((message, severity = "info") => {
        if (!message) return
        setSnack({ open: true, message, severity })
    }, [])

    const trackFacebookEvent = useCallback((eventName, payload) => {
        if (typeof window === "undefined") return
        if (typeof window.fbq !== "function") return
        window.fbq("track", eventName, payload)
    }, [])

    const closeSnack = useCallback(() => {
        setSnack(prev => ({ ...prev, open: false }))
    }, [])

    const actualizarEnvio = useCallback(debounce((data) => setKeyShipment(prev => prev + 1), 500), []);

    const onChangeCart = useCallback((new_cart) => {
        localStorage.setItem(key_local_storage_cart, JSON.stringify(new_cart))
        setCarrito([...new_cart, ...[]])
        setShipmentMethod(false)
        actualizarEnvio()
    }, [actualizarEnvio])

    const aplicarAjustesInventario = useCallback((respuesta) => {
        if (!respuesta?.productos || !Array.isArray(respuesta.productos)) return
        let cambio = false
        const productosRespuesta = respuesta.productos
        const actualizado = carrito.map(item => {
            const encontrado = productosRespuesta.find(p => p._id === item._id)
            if (!encontrado) return item
            const stockValido = typeof encontrado.totalStock === "number"
            const totalStock = stockValido ? Math.max(0, encontrado.totalStock) : item.totalStock
            let cantidadActual = parseInt(item.cantidad)
            if (isNaN(cantidadActual)) cantidadActual = 0
            let nuevaCantidad = cantidadActual
            if (stockValido && cantidadActual > totalStock) {
                nuevaCantidad = totalStock
                cambio = true
            }
            const resultado = { ...item }
            if (stockValido && item.totalStock !== totalStock) {
                resultado.totalStock = totalStock
                cambio = true
            }
            if (nuevaCantidad !== cantidadActual) {
                resultado.cantidad = nuevaCantidad
            }
            return resultado
        })
        if (!cambio) return
        onChangeCart(actualizado)
    }, [carrito, onChangeCart])

    const validarInventarioCarrito = () => {
        if (!carrito || carrito.length < 1) return
        const body = {
            productos: carrito.map(item => ({ id: item._id, cantidad: item.cantidad }))
        }
        fetch(`${urlapi}/productos/validate-cart`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
            .then(res => res.json())
            .then(res => {
                if (res?.errorMessage) return showSnack(res.errorMessage, "error")
                setInventoryCheck(res)
                aplicarAjustesInventario(res)
                if (res?.requiereAjuste) setInventoryAlert(res)
            })
            .catch(() => {
                showSnack("No se pudo validar inventario", "error")
            })
    }

    useEffect(() => {
        verifyNumber()
        consultarMetodosPago()
        verificarProductosTrash()
    }, [])

    useEffect(() => {
        if (!carrito || carrito.length < 1) return
        const totalItems = carrito.reduce((sum, item) => {
            const qty = parseInt(item.cantidad)
            return sum + (isNaN(qty) ? 0 : qty)
        }, 0)
        const totalValue = calculateTotalCart(carrito)
        trackFacebookEvent("InitiateCheckout", {
            content_ids: carrito.map(item => item._id),
            content_type: "product",
            currency: "CLP",
            num_items: totalItems,
            value: totalValue
        })
    }, [])

    useEffect(() => {
        if (!paymentMethod) return
        if (lastPaymentTracked.current === paymentMethod) return
        lastPaymentTracked.current = paymentMethod
        const totalItems = carrito.reduce((sum, item) => {
            const qty = parseInt(item.cantidad)
            return sum + (isNaN(qty) ? 0 : qty)
        }, 0)
        const totalValue = calculateTotalCart(carrito)
        trackFacebookEvent("AddPaymentInfo", {
            content_ids: carrito.map(item => item._id),
            content_type: "product",
            currency: "CLP",
            num_items: totalItems,
            value: totalValue,
            payment_method: paymentMethod
        })
    }, [paymentMethod, carrito, trackFacebookEvent])

    useEffect(() => {
        validarInventarioCarrito()
        verificarProductosTrash()
    }, [carrito])

    const seleccionMetodo = () => {
        if (loadingPaymentMethods) return <Skeleton count={3} height={50} />
        if (metodos_pago.length < 1) return <p className="text-center">No hay métodos de pago disponibles</p>

        return <div className="mt-3">
            <p>Selecciona el método de pago <b style={{ fontWeight: 600 }}>haciendo click</b></p>
            {/* { !paymentMethod ? <PointerHand /> : false } */}
            {
                metodos_pago.map((e, i) => {
                    return <Card key={`metodo-pago-${i}`} className="mb-3 p-3 hover " style={{ border: paymentMethod === e.name ? "1px solid black" : "none" }} onClick={() => setPaymentMethod(e.name)}>
                        <Row>
                            <Col xs={6}>{paymentMethod === e.name ? <IoMdRadioButtonOn /> : <IoIosRadioButtonOff />}  {logos[e.name] ? <img style={{ maxWidth: 100 }} src={logos[e.name]} alt={e.name} /> : <h5 className="mb-0 d-inline-block">{e.name}</h5>}</Col>
                            <Col xs={6} className="text-right"><p className="mb-0">{e.description}</p></Col>
                        </Row>
                    </Card>
                })
            }
        </div>
    }

    const handleChangeGift = (e) => {
        const { name, value } = e.target
        setCheckout(prev => {
            return {
                ...prev,
                giftOptions: {
                    ...prev.giftOptions,
                    [name]: value
                }
            }
        })
    }

    const procesarPagoWebpay = async (url, token) => {
        if (url && token) {
            // Crea un formulario dinámico
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;

            // Crea un input oculto para el token
            const inputToken = document.createElement('input');
            inputToken.type = 'hidden';
            inputToken.name = 'token_ws';
            inputToken.value = token;

            form.appendChild(inputToken);
            document.body.appendChild(form);

            // Envía el formulario
            form.submit();
        }
    }

    /**
     * Khipu se paga en su propio sitio, con redirección completa.
     *
     * El widget en modal quedó descartado: el comprador sale a Khipu, paga, y vuelve por el
     * `return_url` que apunta al backend, que confirma el pago antes de devolverlo a su pedido. Ese
     * rodeo es justamente lo que hace que la orden ya esté pagada cuando la ve, y con el modal no
     * existía —Khipu no redirige nada y no había vuelta que interceptar—.
     */
    const iniciarPagoKhipu = (res, id) => {
        if (!res?.payment_url) return showSnack("No se pudo iniciar el pago, intenta nuevamente", "error")

        // Respaldo para la página de la orden: si el pago quedara sin confirmar, es lo que permite
        // preguntarle a Khipu por este cobro en concreto.
        try { sessionStorage.setItem(`khipu_payment_${id}`, res.payment_id) } catch (error) { }

        return window.location = res.payment_url
    }

    const payByMethod = (res, id, payment_method) => {
        if (payment_method === "webpay") {
            if (res?.url && res?.token) {
                procesarPagoWebpay(res?.url, res?.token)
            } else {
                showSnack("Ocurrió un error al procesar el pago", "error")
            }
        } else if (payment_method === "fintoc") {
            if (res.id) {
                if (window.Fintoc) {
                    const widget = window.Fintoc.create({
                        sessionToken: res.session_token,
                        product: 'payments',
                        publicKey: 'pk_test__ZVaFZ4Za8AT_nAnWEAx7zyx7RxigHuztsuw1eUs1HM',
                        onSuccess: () => window.location = `/order-details/${id}`,
                    });
                    widget.open();
                } else {
                    showSnack("Método de pago no disponible por el momento", "error")
                }
            }
        } else if (payment_method === "khipu") {
            iniciarPagoKhipu(res, id)
        } else if (payment_method === "transferencia") {
            window.location = `/order-details/${id}`
        }
    }

    const verificarProductosTrash = useCallback(async () => {
        if (!carrito || carrito.length < 1) {
            setTrashedIds([])
            return []
        }
        const ids = carrito.map(p => p._id).filter(Boolean)
        if (ids.length < 1) {
            setTrashedIds([])
            return []
        }

        setLoadingTrash(true)

        try {
            const response = await fetch(`${urlapi}/productos/check-trash`, {
                method: 'POST',
                body: JSON.stringify({ ids }),
                headers: { 'Content-Type': 'application/json' }
            })
            const res = await response.json()

            let ids_trashed = []
            if (res?.trashed && Array.isArray(res.trashed) && res.trashed.length > 0) {
                ids_trashed = res.trashed.map(p => p._id)
                setTrashedIds(ids_trashed)
            } else {
                setTrashedIds([])
            }
            setLoadingTrash(false)
            return ids_trashed
        } catch (error) {
            console.error('Error verificando productos trash:', error.message)
            setLoadingTrash(false)
            return []
        }
    }, [carrito])

    const consultarMetodosPago = async () => {
        setLoadingPaymentMethods(true)
        return fetch(`${urlapi}/payments/methods`, {
            method: 'POST',
            body: JSON.stringify({
                host: window.location.host
            }),
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then(res => {
                if (Array.isArray(res)) setMetodosPago(res.map(e => ({ name: e.sub_tipo, id: e.sub_tipo, logo: logos[e.sub_tipo], description: descripciones[e.sub_tipo] })))
                return setLoadingPaymentMethods(false)
            })
            .catch(error => {
                setLoadingPaymentMethods(false)
            })
    }

    const pagarPedido = async (id, payment_) => {
        const payment_method = payment_.toString().toLowerCase()
        return fetch(`${urlapi}/payments/pay`, {
            method: 'POST',
            body: JSON.stringify({
                id,
                payment_method
            }),
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then(res => {
                // Khipu responde con `errorMessage` cuando el cobro no se pudo crear (sin
                // credenciales, monto rechazado). Sin esto el comprador ve un error genérico.
                if (res?.errorMessage) {
                    showSnack(res.errorMessage, "error")
                    return setLoading(false)
                }
                payByMethod(res, id, payment_method)
                return setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }

    const completarPedido = async () => {
        setLoading(true)

        // Validación final de productos en trash
        const currentTrashed = await verificarProductosTrash()
        if (currentTrashed && currentTrashed.length > 0) {
            setLoading(false)
            return showSnack("Hay productos en tu carrito que ya no están disponibles. Por favor, elimínalos para continuar.", "warning")
        }


        if (!paymentMethod) {
            setLoading(false)
            return showSnack("Debes seleccionar un método de pago", "warning")
        }
        const indexarMetodosPago = metodos_pago.reduce((prev, next) => {
            prev[next.name] = next.id
            return prev
        }, {})

        if (idPedido) {
            return pagarPedido(idPedido, indexarMetodosPago[paymentMethod])
        }

        const requeridos = [
            { name: "first_name", label: "nombre" },
            { name: "email", label: "correo" },
            { name: "phone", label: "teléfono" },
            { name: "address_1", label: "dirección" },
        ]
        let faltantes = []
        requeridos.forEach((e) => {
            if (!user.billing[e.name]) faltantes.push(e.label)
        })
        if (faltantes.length > 0) {
            setLoading(false)
            return showSnack("Falta ingresar " + faltantes.join(", "), "warning")
        }
        if (!validateEmail(user.billing.email)) {
            setLoading(false)
            return showSnack("Correo electrónico inválido", "warning")
        }

        const direccion = user.billing.address_1
        const i = direcciones.findIndex((e) => e.formated_address === direccion)
        const requeridos_direccion = [
            // { name: "tipo", label: "Tipo de dirección" },
            // { name: "address_2", label: "Depto./Oficina/Piso"},
            // { name: "depto", label: "Nombre de la empresa o edificio"},
            // { name: "notas", label: "Instrucciones y/o observaciones"},
        ]
        requeridos_direccion.forEach((e) => {
            if (!direcciones[i][e.name]) faltantes.push(e.label)
        })
        if (faltantes.length > 0) {
            setLoading(false)
            return showSnack("Falta ingresar " + faltantes.join(", "), "warning")
        }

        if (!shipmentMethod) {
            setLoading(false)
            return showSnack("Debes seleccionar un método de envío", "warning")
        }
        if (!paymentMethod) {
            setLoading(false)
            return showSnack("Debes seleccionar un método de pago", "warning")
        }

        const envio = shipmentMethod?.fee ? shipmentMethod?.fee : 0

        let calcular_total = calculateTotalCart(carrito)

        const payload = {
            sub_total: Math.round(calcular_total),
            shipping_total: Math.round(envio),
            total: Math.round(calcular_total + envio),
            data: user,
            productos: carrito,
            host: window.location.host,
            payment_method: paymentMethod,
            shipment_data: shipmentMethod,
            checkout
        }

        if (discountValid?.valor) {
            let discountMonto = discountValid.valor;
            if (discountValid.tipo_descuento === 'porcentaje') {
                discountMonto = (calcular_total * discountValid.valor) / 100;
                if (discountValid.monto_maximo && discountMonto > discountValid.monto_maximo) {
                    discountMonto = discountValid.monto_maximo;
                }
            }
            payload.discount = {
                _id: discountValid._id,
                title: discountValid.nombre,
                value: discountMonto,
                tipo: discountValid.tipo_descuento,
                porcentaje_valor: discountValid.valor,
                monto_maximo: discountValid.monto_maximo
            }
            payload.total = Math.round(payload.total - discountMonto)
        }
        if (direcciones[i].address_2) payload.data.billing.address_2 = direcciones[i].address_2

        setLoading(true)

        return fetch(`${urlapi}/ordenes/web/new`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => {
                return res.json()
            })
            .then(res => {
                if (!res) {
                    showSnack('Sin datos', "error")
                } else if (res.errorMessage) {
                    showSnack(res.errorMessage, "error")
                } else if (res._id) {
                    pagarPedido(res._id, indexarMetodosPago[paymentMethod])
                    setIdPedido(res._id)
                }
                // return setLoadingCreacion(false)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
                showSnack("Error al consultar la información, intente nuevamente", "error")
                // return setLoadingCreacion(false)
            })
    }

    const giftOptions = () => {
        if (!checkout.isGift) return false
        return <div>
            <Card className="p-3 shadow">

                <Row>
                    <Col md={4}>
                        <h5><GoGift size={40} /></h5>
                        <h5 className="mb-0">Sobre tu obsequio </h5>
                    </Col>
                    <Col md={4}>
                        <label className="form-control-label d-block">De</label>
                        <input className="form-control mb-0" value={checkout.giftOptions?.de} name="de" onChange={handleChangeGift} />
                    </Col>
                    <Col md={4}>
                        <label className="form-control-label d-block">Para</label>
                        <input className="form-control mb-0" value={checkout.giftOptions?.para} name="para" onChange={handleChangeGift} />
                    </Col>
                </Row>
            </Card>
        </div>
    }

    const resumen = () => {
        let calcular_total = carrito.reduce((prev, next) => {
            let cantidad = parseInt(next.cantidad)
            if (isNaN(cantidad)) cantidad = 0
            return prev + (next.precio * cantidad)
        }, 0)

        const envio = shipmentMethod?.fee ? shipmentMethod?.fee : 0

        return <div>
            <h4>Resumen</h4>
            <Card className="p-3">
                <Carrito
                    typeView="very-simple"
                    onChangeCarrito={(e) => onChangeCart(e)}
                    carrito={carrito}
                    replaceAction={<div></div>}
                    loadingTrash={loadingTrash}
                    trashedIds={trashedIds}
                />
                <Row>
                    <Col md={6} xs={0}></Col>
                    <Col md={2} xs={6}>Sub total</Col>
                    <Col md={4} xs={6} className="text-right">{formatoMoneda(Math.round(calcular_total))}</Col>

                    <Col md={6} xs={0}></Col>
                    <Col md={2} xs={6}>Envío</Col>
                    <Col md={4} xs={6} className="text-right">{formatoMoneda(envio)}</Col>

                    {
                        discountValid ? (() => {
                            let discountMonto = discountValid.valor;
                            if (discountValid.tipo_descuento === 'porcentaje') {
                                discountMonto = (calcular_total * discountValid.valor) / 100;
                                if (discountValid.monto_maximo && discountMonto > discountValid.monto_maximo) {
                                    discountMonto = discountValid.monto_maximo;
                                }
                            }
                            return (
                                <>
                                    <Col md={6} xs={0}></Col>
                                    <Col md={2} xs={6}>Descuento {discountValid.tipo_descuento === 'porcentaje' ? `(${discountValid.valor}%)` : ''}</Col>
                                    <Col md={4} xs={6} className="text-right">- {formatoMoneda(Math.round(discountMonto))}</Col>
                                </>
                            );
                        })() : <>
                        </>
                    }

                    <Col md={6} xs={0}></Col>
                    <Col md={2} xs={6}>Total</Col>
                    <Col md={4} xs={6} className="text-right">{
                        formatoMoneda(Math.round(calcular_total + envio - (discountValid ? (() => {
                            let discountMonto = discountValid.valor;
                            if (discountValid.tipo_descuento === 'porcentaje') {
                                discountMonto = (calcular_total * discountValid.valor) / 100;
                                if (discountValid.monto_maximo && discountMonto > discountValid.monto_maximo) {
                                    discountMonto = discountValid.monto_maximo;
                                }
                            }
                            return discountMonto;
                        })() : 0)))
                    }</Col>

                </Row>
            </Card>
        </div>
    }

    const verifyNumber = () => {
        const instancia_usuario = JSON.parse(JSON.stringify(user))
        if (!instancia_usuario.billing.phone) {
            instancia_usuario.billing.phone = "56"
            dispatch(refrescarUser(instancia_usuario))
        }
    }

    const handleSubmitCode = (e) => {
        if (e && e.preventDefault) e.preventDefault()
        if (!discountCode) return
        setLoadingDiscount(true)
        return fetch(`${urlapi}/descuentos/validate`, {
            method: 'POST',
            body: JSON.stringify({
                code: discountCode,
            }),
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then(res => {
                if (res && res._id) {
                    let calcular_total = calculateTotalCart(carrito)
                    if (res.monto_minimo && calcular_total < res.monto_minimo) {
                        setDiscountValid(false)
                        showSnack(`El carrito debe tener un mínimo de $${res.monto_minimo} para aplicar este descuento`, "warning")
                    } else {
                        setDiscountValid(res)
                        showSnack("Código de descuento válido", "success")
                    }
                } else {
                    setDiscountValid(false)
                    showSnack("Código de descuento inválido", "warning")
                }
                setLoadingDiscount(false)
            })
            .catch(error => {
                setDiscountValid(false)
                showSnack("Error al validar el código de descuento", "error")
                setLoadingDiscount(false)
            })
    }

    const showDiscount = () => {
        if (discountValid) return <div>
            <h6><MdOutlineDiscount /> ¡Código de descuento aplicado!</h6>
        </div>
        return <div>
            <form className="mt-3" onSubmit={handleSubmitCode}>
                <div className="align-items-center d-flex">
                    <input type="text" className="mr-2 form-control" onChange={(e) => setDiscountCode(e.target.value)} placeholder="Código de descuento" />
                    <Button type="submit" disabled={loadingDiscount} onClick={() => handleSubmitCode()} variant="primary"><FaCheck /></Button>
                </div>

                <span>Escribe tu código de descuento y presiona enter</span>
                {loadingDiscount && <LinearProgress />}
            </form>
        </div>
    }

    const handleChangeUser = (e) => {
        const { name, value } = e.target
        const instancia_usuario = JSON.parse(JSON.stringify(user))
        let valor = value
        if (name === "phone") {
            const prefix = "56";
            if (value.startsWith(prefix)) {
                valor = value;
            } else {
                valor = value.length < 2 ? prefix : (prefix + valor)
            }
            valor = valor.substring(0, 11)
        }
        instancia_usuario.billing[name] = valor
        dispatch(refrescarUser(instancia_usuario))
    }

    const seleccionarEnvio = (tar) => {
        return setShipmentMethod(tar)
    }

    const alertInventario = () => {
        const alerta = inventoryAlert || inventoryCheck
        if (!alerta?.productos || !alerta.requiereAjuste) return false
        const productosAjustados = alerta.productos.filter(p => p.requiereAjuste)
        if (productosAjustados.length < 1) return false
        const indexCarrito = carrito.reduce((acc, item) => {
            acc[item._id] = item
            return acc
        }, {})
        return <Alert severity="warning" className="mb-3">
            <div><b>Se ajustaron productos por stock disponible.</b></div>
            <ul className="mb-0">
                {
                    productosAjustados.map(p => {
                        const prod = indexCarrito[p._id] || {}
                        const nombre = prod.titulo || p._id
                        const solicitado = typeof p.solicitado === "number" ? p.solicitado : prod.cantidad
                        const disponible = typeof p.totalStock === "number" ? p.totalStock : 0
                        return <li key={p._id}>{nombre}: solicitado {solicitado}, disponible {disponible}</li>
                    })
                }
            </ul>
        </Alert>
    }

    return <div style={{ height: "100%" }}>
        <Row noGutters style={{ height: "100%" }}>
            <Col md={6} xs={12} >
                <div className="p-5">
                    {sitio.logo ? (
                        <img
                            src={sitio.logo}
                            alt="Logo"
                            className="mb-3"
                            style={{ maxHeight: 50, maxWidth: "100%" }}
                        />
                    ) : (
                        <h2>{sitio.titulo}</h2>
                    )}
                    <Link to="/"><p className="text-dark d-inline-block"><FaAngleLeft /> <b>Volver a la tienda</b></p></Link>
                    {alertInventario()}
                    <h4>Tu información</h4>
                    <Row>
                        <Col md={4} xs={12}>
                            <label className="form-control-label d-block">Tu nombre</label>
                            <input className="form-control mb-3" value={user?.billing?.first_name} placeholder="Tu nombre y apellido" name="first_name" onChange={handleChangeUser} />
                        </Col>
                        <Col md={4} xs={12}>
                            <label className="form-control-label d-block">Correo electrónico</label>
                            <input className="form-control mb-3" value={user?.billing?.email} placeholder="Tu email" name="email" onChange={handleChangeUser} />
                        </Col>
                        <Col md={4} xs={12}>
                            <label className="form-control-label d-block">Teléfono</label>
                            <input className="form-control mb-3" value={user?.billing?.phone} placeholder="Tu móvil" name="phone" onChange={handleChangeUser} onClick={() => verifyNumber()} />
                        </Col>
                    </Row>

                    <Form.Group className="mb-0" style={{ fontSize: 14 }} controlId="alsalir">
                        <Form.Check type="switch"
                            label={<div><GoGift /> Es un regalo</div>}
                            onChange={(e) => {
                                setCheckout(prev => {
                                    const val = e.target.checked
                                    if (!val) {
                                        return {
                                            ...prev,
                                            isGift: val,
                                            giftOptions: {}
                                        }
                                    }
                                    return {
                                        ...prev,
                                        isGift: e.target.checked
                                    }
                                })
                            }}
                            className="mb-3"
                        />
                    </Form.Group>
                    {giftOptions()}
                    <hr />
                    <h4>Detalles del envío</h4>

                    <DireccionUsuario typeView="checkout" />
                    {/* <Carrito typeView="simple" carrito={carrito} replaceAction={<div></div>} /> */}
                </div>
            </Col>
            <Col md={6} xs={12} style={{ background: "#dcdfe1" }}>
                <div className="p-5">
                    {resumen()}
                    <hr />
                    <h4>Envío</h4>
                    {/* { !shipmentMethod ? <PointerHand /> : false } */}
                    {
                        user?.billing?.address_1 ? <DespachoOrden key={key_shipment} selected={shipmentMethod} onSelect={(tar) => seleccionarEnvio(tar)} lat={user?.geo_datos?.lat} lng={user?.geo_datos?.lng} geo_datos={user?.geo_datos} /> : <h6><FaTruckFast size={25} /> Introduce tu dirección para visualizar las opciones de envío</h6>
                    }
                    <hr />

                    <h4>Detalles del pago</h4>
                    <p>Completa tu compra seleccionando tu opción preferida para comprar</p>
                    {seleccionMetodo()}
                    {showDiscount()}
                    {trashedIds.length > 0 && <Alert severity="error" className="mt-3">Tienes productos no disponibles en tu carrito. Por favor, elimínalos para continuar.</Alert>}
                    <Button
                        variant={trashedIds.length > 0 ? "secondary" : "primary"}
                        className="w-100 mt-3"
                        disabled={loading || loadingTrash || trashedIds.length > 0}
                        onClick={() => completarPedido()}
                    >
                        {loading || loadingTrash ? "ESPERE UN MOMENTO..." : trashedIds.length > 0 ? "TIENES OBSERVACIONES EN TU CARRITO" : "COMPLETAR Y PAGAR"}
                    </Button>
                </div>
            </Col>
        </Row>
        <Snackbar
            open={snack.open}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            autoHideDuration={3000}
            onClose={closeSnack}
        >
            <Alert
                onClose={closeSnack}
                severity={snack.severity || "info"}
                variant="filled"
                sx={{ width: '100%', background: "#000", color: "#fff" }}
            >
                {snack.message}
            </Alert>
        </Snackbar>
    </div>
}

export default Checkout
